import { render, staticRenderFns } from "./channel-item.vue?vue&type=template&id=3ffa2ebf&scoped=true&"
import script from "./channel-item.vue?vue&type=script&lang=js&"
export * from "./channel-item.vue?vue&type=script&lang=js&"
import style0 from "./channel-item.vue?vue&type=style&index=0&id=3ffa2ebf&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ffa2ebf",
  null
  
)

export default component.exports